export { PlaceholderIcon as MouthUnderLipIcon } from "./placeholder";
